"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupService = void 0;
var tslib_1 = require("tslib");
var GroupApi_1 = require("./GroupApi");
var GroupService = /** @class */ (function () {
    function GroupService(context) {
        this.context = context;
        this.api = new GroupApi_1.GroupApi(context);
        this.storage = context.getWebStorage();
    }
    GroupService.prototype.createGroup = function (payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.createGroup(payload)];
                    case 1:
                        data = (_a.sent()) || {};
                        this.cacheGroups([data.group]);
                        return [2 /*return*/, data];
                }
            });
        });
    };
    GroupService.prototype.updateGroup = function (payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.updateGroup(payload)];
                    case 1:
                        data = (_a.sent()) || {};
                        this.cacheGroups([data.group]);
                        return [2 /*return*/, data];
                }
            });
        });
    };
    GroupService.prototype.deleteGroup = function (payload) {
        this.storage.removeItem(payload.groupId);
        return this.api.deleteGroup(payload);
    };
    GroupService.prototype.getGroupById = function (groupId, noCache) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getGroup({ groupId: groupId }, noCache)];
                    case 1:
                        data = (_a.sent()) || {};
                        return [2 /*return*/, data.group];
                }
            });
        });
    };
    GroupService.prototype.cacheGroups = function (groups) {
        var e_1, _a;
        try {
            try {
                for (var groups_1 = tslib_1.__values(groups), groups_1_1 = groups_1.next(); !groups_1_1.done; groups_1_1 = groups_1.next()) {
                    var group = groups_1_1.value;
                    var stringify = JSON.stringify(group);
                    this.storage.setItem(group.id, stringify);
                    this.storage.setItem(group.slug, stringify);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (groups_1_1 && !groups_1_1.done && (_a = groups_1.return)) _a.call(groups_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        catch (e) {
            console.log('Error in [GroupService.cacheGroups]');
        }
    };
    GroupService.prototype.getGroupsFromCache = function (ids) {
        var _this = this;
        return ids.reduce(function (acc, id) {
            try {
                var groupFromCache = _this.storage.getItem(id);
                if (groupFromCache) {
                    acc.push(JSON.parse(groupFromCache));
                }
            }
            catch (e) {
                console.log('Error in [GroupService.getGroupsFromCache]');
            }
            return acc;
        }, []);
    };
    GroupService.prototype.getGroup = function (payload, noCache) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, group, data;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (noCache !== true) {
                            _a = tslib_1.__read(this.getGroupsFromCache([payload.groupId]), 1), group = _a[0];
                            if (group) {
                                return [2 /*return*/, { group: group }];
                            }
                        }
                        return [4 /*yield*/, this.api.getGroup(payload)];
                    case 1:
                        data = (_b.sent()) || {};
                        this.cacheGroups([data.group]);
                        return [2 /*return*/, data];
                }
            });
        });
    };
    GroupService.prototype.getGroupBySlug = function (payload, noCache) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var slug, _a, group, data;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (noCache !== true) {
                            slug = payload.slug;
                            _a = tslib_1.__read(this.getGroupsFromCache([slug]), 1), group = _a[0];
                            if (group) {
                                return [2 /*return*/, { group: group }];
                            }
                        }
                        return [4 /*yield*/, this.api.getGroupBySlug(payload)];
                    case 1:
                        data = (_b.sent()) || {};
                        this.cacheGroups([data.group]);
                        return [2 /*return*/, data];
                }
            });
        });
    };
    GroupService.prototype.listGroups = function (payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var listGroups;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.listGroups(payload)];
                    case 1:
                        listGroups = (_a.sent()) || {};
                        this.cacheGroups(listGroups.groups);
                        return [2 /*return*/, listGroups];
                }
            });
        });
    };
    GroupService.prototype.queryGroups = function (payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var queryGroups;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.queryGroups(payload)];
                    case 1:
                        queryGroups = (_a.sent()) || {};
                        this.cacheGroups(queryGroups.groups);
                        return [2 /*return*/, queryGroups];
                }
            });
        });
    };
    GroupService.prototype.queryGroupsWithRelationshipsByIds = function (ids) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var payload, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = {
                            siteMemberId: this.context.getCurrentUser().id,
                            query: {
                                filter: {
                                    id: {
                                        $hasSome: ids,
                                    },
                                },
                                paging: {
                                    offset: 0,
                                    limit: ids.length,
                                },
                            },
                        };
                        return [4 /*yield*/, this.queryGroupsWithRelationships(payload)];
                    case 1:
                        data = (_a.sent()) || {};
                        return [2 /*return*/, data.groupWithRelationship];
                }
            });
        });
    };
    GroupService.prototype.queryGroupsWithRelationships = function (payload) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var queryGroupsWithRelationships;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.api.queryGroupsWithRelationships(payload)];
                    case 1:
                        queryGroupsWithRelationships = (_b.sent()) || {};
                        this.cacheGroups((_a = queryGroupsWithRelationships.groupWithRelationship) === null || _a === void 0 ? void 0 : _a.map(function (g) { return g.group; }));
                        return [2 /*return*/, queryGroupsWithRelationships];
                }
            });
        });
    };
    GroupService.prototype.queryGroupRequests = function (payload) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var queryGroupRequests;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.api.queryGroupRequests(payload)];
                    case 1:
                        queryGroupRequests = _b.sent();
                        this.cacheGroups((_a = queryGroupRequests.groupRequests) === null || _a === void 0 ? void 0 : _a.map(function (g) { return g.group; }));
                        return [2 /*return*/, queryGroupRequests];
                }
            });
        });
    };
    GroupService.prototype.listGroupRequests = function (payload) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var listGroupRequests;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.api.listGroupRequests(payload)];
                    case 1:
                        listGroupRequests = _b.sent();
                        this.cacheGroups((_a = listGroupRequests.groupRequests) === null || _a === void 0 ? void 0 : _a.map(function (g) { return g.group; }));
                        return [2 /*return*/, listGroupRequests];
                }
            });
        });
    };
    GroupService.prototype.approveGroupRequests = function (payload) {
        return this.api.approveGroupRequests(payload);
    };
    GroupService.prototype.rejectGroupRequests = function (payload) {
        return this.api.rejectGroupRequests(payload);
    };
    GroupService.prototype.submitGroupRequest = function (payload) {
        return this.api.submitGroupRequest(payload);
    };
    GroupService.prototype.cancelGroupRequest = function (payload) {
        return this.api.cancelGroupRequest(payload);
    };
    return GroupService;
}());
exports.GroupService = GroupService;
//# sourceMappingURL=GroupService.js.map